import React from 'react'

import LoadingBox from 'src/ui/LoadingBox/LoadingBox'

import TopicInfoSkeleton from './TopicInfoSkeleton'

const TopicInfoPlaceholder = () => (
  <TopicInfoSkeleton
    nameSection={
      <LoadingBox width="81px" maxWidth="100%">
        &nbsp;
      </LoadingBox>
    }
    descriptionSection={
      <>
        <LoadingBox width="322px" maxWidth="100%">
          &nbsp;
        </LoadingBox>
        <LoadingBox width="218px" maxWidth="100%" mt="11px">
          &nbsp;
        </LoadingBox>
      </>
    }
    imageSection={<LoadingBox width="100%" height="176px" />}
  />
)

export default TopicInfoPlaceholder
